/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import Hover from "../../components/hover";

export const getInterrogationDate = (item) => {
  const newTimeZone = new Date(item.interrogationDate)
    .toLocaleTimeString("en-us", { hour12: false, hourCycle: "h23", timeZoneName: "short" })
    .split(" ");
  return (
    <Hover onHover={item?.interrogationDate ? `${newTimeZone[0]}` : "-"}>
      {new Date(item.interrogationDate).toLocaleDateString() || "-"}
    </Hover>
  );
};

export const getThirtyDayBillStatus = (item) => {
  return item.thirtyDayBillStatus === "BILLABLE" ? (
    <Hover
      onHover={
        item?.thirthyCycleEnd ? "DS:" + new Date(item?.thirthyCycleEnd).addDays(1).toShortDateFormat() : "-"
      }
    >
      {item.thirtyDayBillStatus || "-"}
    </Hover>
  ) : (
    item.thirtyDayBillStatus || "-"
  );
};

export const getNintyDayBillStatus = (item) => {
  return item.nintyDayBillStatus === "BILLABLE" ? (
    <Hover
      onHover={
        item?.nintyCycleEnd ? "DS:" + new Date(item?.nintyCycleEnd).addDays(1).toShortDateFormat() : "-"
      }
    >
      {item.nintyDayBillStatus || "-"}
    </Hover>
  ) : (
    item.nintyDayBillStatus || "-"
  );
};

export const getStatus = (item) => {
  const status = item?.interrogationStatus;
  switch (status) {
    case "NOTASSIGNED":
      return "Not Assigned";
    case "TERMINATED":
      return "Removed";
    default:
      return status.charAt(0) + status.slice(1).toLocaleLowerCase();
  }
};

export const renderPriorityFlag = (item) => {
  if (item.priorityFlag === "RED")
    return <div className="alert-status-danger" style={{ width: 25, height: 25 }} />;
  if (item.priorityFlag === "YELLOW")
    return <div className="alert-status-warning" style={{ width: 25, height: 25 }} />;
  else return null;
};

export const getDefaultSort = (activeTab) => {
  switch (activeTab) {
    case "poc":
      return ["flagSort", "interrogationDate", "id"];
    case "remote":
      return ["flagSort", "interrogationDate", "id"];
    case "all":
      return ["-interrogationDate", "-id"];
    case "unprocessed":
      return ["flagSort", "interrogationDate", "id"];
    case "followup":
      return ["flagSort", "interrogationDate", "id"];
    case "biotel":
      return ["-interrogationDate", "-id"];
    default:
      return ["flagSort", "interrogationDate", "id"];
  }
};
